export default {
  setDict: (state, data) => {
    
    //Only SiteCircle and Other available by default
    const payrollCompanies = data['PAYROLL_COMPANY']?.filter( pt => pt.value  === 'Other' || pt.value === 'PAYE' || pt.value === 'CIS')
    data['PAYROLL_COMPANY'] = (payrollCompanies ?? []).toSorted( (a,b) => (a.dictionary_order ?? 0) - (b.dictionary_order ?? 0))

    data['DOCUMENT_TYPE'].sort( (a,b) => a.value.localeCompare(b.value))
    state.data = data
  },
  setLocations: (state, data) => {
    state.locations = data
  },
  setHasData: state => {
    state.hasData = true
  },
  toggleInitialised: (state, flag) => {
    state.isInitialised = flag
  },
};
